import React from 'react';
import { Typography, Box } from '@mui/material';

// Bolds any line that is exactly "Valuetech S.r.l."
const renderText = (text) =>
  text.split('\n').map((line, i, arr) => (
    <React.Fragment key={i}>
      {line === 'Valuetech S.r.l.' ? <strong>{line}</strong> : line}
      {i < arr.length - 1 && '\n'}
    </React.Fragment>
  ));

// Renders a section with plain paragraphs. Expects { title, content[] }.
export const TextSection = ({ section, color }) => (
  <>
    <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color, fontWeight: 700 }}>
      {section.title}
    </Typography>
    {section.content && section.content.map((paragraph, idx) => (
      <Typography key={idx} variant="body1" paragraph sx={{ whiteSpace: 'pre-line' }}>
        {renderText(paragraph)}
      </Typography>
    ))}
  </>
);

// Renders a section with an intro + bulleted list. Expects { title, intro, items[], footer? }.
// Items can be strings or { label, text } objects (label rendered in bold).
export const ListSection = ({ section, color }) => (
  <>
    <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color, fontWeight: 700 }}>
      {section.title}
    </Typography>
    {section.intro && (
      <Typography variant="body1" paragraph>
        {section.intro}
      </Typography>
    )}
    <Box component="ul" sx={{ pl: 3, mb: 2 }}>
      {section.items && section.items.map((item, idx) => (
        <Typography component="li" variant="body1" sx={{ mb: 1 }} key={idx}>
          {typeof item === 'string' ? item : <><strong>{item.label}</strong> {item.text}</>}
        </Typography>
      ))}
    </Box>
    {section.footer && (
      <Typography variant="body1" paragraph>
        {section.footer}
      </Typography>
    )}
  </>
);

export const Section = ({ section, color }) =>
  section.items
    ? <ListSection section={section} color={color} />
    : <TextSection section={section} color={color} />;